import React from "react";
import styled, { css } from "styled-components";
import { Col } from "../ui/wrapper";
import Button from "../ui/button";

export const SuccessTitle = styled.h5`
  font-weight: 400;
  line-height: 1.3;
  color: rgb(68, 68, 67);
  margin-top: 32px;
  margin-bottom: 16px;
  font-size: 2.25rem;
`;

const JobApplyFormSuccessMessage = () => {

    return (
        <>
            <SuccessTitle>
                Thank you! We have received your application. 
                <br/>We will revert at the earliest, after reviewing it.
            </SuccessTitle>
            <Col lg={12} pl={0}>
            <Button 
                mt="30px" 
                hover={3}
                to={"/"}
            >
                Ok, Go Back
            </Button>
            </Col>
        </>
    )
}

const JobApplyFormErrorMessage = ({resetStatuses}) => {

    return (
        <>
            <SuccessTitle>
            There was an error when saving your details. 
                <br/>Please try again.
            </SuccessTitle>
            <Col lg={12} pl={0}>
            <Button 
                mt="30px" 
                hover={3}
                onClick={ () => resetStatuses()}
            >
                Ok, Try Again
            </Button>
            </Col>
        </>
    )
}

const JobApplySubmittingMessage = () => {

    return (
        <>
            <SuccessTitle>
                Please wait, submitting your application.
            </SuccessTitle>
        </>
    )
}

export {JobApplySubmittingMessage,JobApplyFormSuccessMessage, JobApplyFormErrorMessage};